import { enablePointerEvents } from '@utils/pointer-events-control';
let cam,
  left = 1,
  right = 1,
  count = 0,
  round = 1,
  entry = 0,
  level = 1,
  container,
  container2,
  container3,
  child;
const textArray = [];
let bar, reward, goldMeter, bottom, singleCoin;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'GameScene',
    });
  }

  preload() {
    this.load.atlas(
      'confetti',
      'assets/GameScene/confettiAnim.png',
      'assets/GameScene/confettiAnim.json',
    );
    this.load.atlas(
      'singleCoin',
      'assets/G2 Game Anims/single coin anim/goldCoinAnim.png',
      'assets/G2 Game Anims/single coin anim/goldCoinAnim.json',
    );
    this.load.atlas(
      'goldMeter',
      'assets/G2 Game Anims/gold meter anim/goldMeterAnim.png',
      'assets/G2 Game Anims/gold meter anim/goldMeterAnim.json',
    );

    //audio
    this.load.audio('wrongAnswer', 'assets/G1 & G2 Game Sounds/wrongAnswer.mp3');
    this.load.audio('correctAnswer', 'assets/G1 & G2 Game Sounds/correctAnswer.mp3');
    this.load.audio('lockerHandle', 'assets/G1 & G2 Game Sounds/lockerHandleRotate.mp3');
    this.load.audio('lockerDoor', 'assets/G1 & G2 Game Sounds/lockerDoorOpening.mp3');
    this.load.audio('coinReveal', 'assets/G1 & G2 Game Sounds/coinReveal.mp3');
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    cam = this.cameras.main;
    cam.setBounds(0, 0, 1280, 720);
    cam.fadeIn(500, 255, 255, 255);
    this.BG3 = this.add
      .image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'BG3')
      .setScale(0.23);
    this.almirah = this.add.image(480, 410, 'almirah').setScale(0.21);
    this.backLock = this.add.image(506, 290, 'backLock').setScale(0.15);
    this.backLock2 = this.add.image(505, 520, 'backLock').setScale(0.15);
    this.bolt = this.add.image(355, 284, 'bolt').setScale(0.17);
    this.bolt2 = this.add.image(354, 514, 'bolt').setScale(0.17);
    this.coinPiles = this.add.sprite(468, 270, 'coinPile').setScale(0.36);
    this.coinPiles2 = this.add.sprite(468, 500, 'coinPile').setScale(0.36);
    this.locker1 = this.add.image(510, 290, 'locker1').setScale(0.15);
    this.locker2 = this.add.image(510, 520, 'locker2').setScale(0.15);
    this.wheel1 = this.add.image(425, 290, 'wheel').setScale(0.35);
    this.wheel2 = this.add.image(425, 520, 'wheel').setScale(0.35);

    this.inputBox = this.add
      .image(597.5, 288, 'disabled')
      .setScale(0.334)
      .disableInteractive();
    this.inputBox2 = this.add
      .image(553.5, 517.5, 'disabled2')
      .setVisible(false)
      .setScale(0.296)
      .disableInteractive();
    this.inputText = this.add
      .text(589, 276, '', { fontFamily: 'font2', fontSize: '24px', fill: '#2B2B2B' })
      .setResolution(5.0);

    this.cursor = this.add
      .image(597, 282, 'cursor')
      .setScale(0.5)
      .setOrigin(0)
      .setVisible(false);
    this.position = this.add.sprite(640, 360);
    this.time.delayedCall(
      1500,
      () => {
        //cam.centerOn(450,290)
        //cam.zoomTo(2.6, 400);
        this.tweens.add({
          targets: this.position,
          x: 450,
          y: 290,
          onprogress: () => {
            cam.zoomTo(2.6, 300);
          },
          ease: 'Linear',
          duration: 300,
          repeat: 0,
        });

        this.scene.launch('DemoScene');

        this.time.delayedCall(
          750,
          () => {
            this.tweens.add({
              targets: container2,
              x: 200,
              ease: 'Linear',
              duration: 500,
              delay: 250,
              repeat: 0,
            });
            //console.log(container2.x);
          },
          [],
          this,
        );
      },
      [],
      this,
    );

    this.time.delayedCall(
      3000,
      () => {
        this.leftText = this.add
          .text(502, 275, '', { fontFamily: 'font2', fontSize: '25px', fill: '#2B2B2B' })
          .setResolution(5.0);
        this.rightText = this.add
          .text(540, 275, '', { fontFamily: 'font2', fontSize: '25px', fill: '#2B2B2B' })
          .setResolution(5.0);

        left = 0;
        right = 0;
        this.plus = this.add.image(529, 290, 'plus').setScale(0.2);
        this.equal = this.add.image(568, 290, 'equal').setScale(0.2);

        this.inputBox.on(
          'pointerup',
          () => {
            entry = 1;
            this.flash = this.plugins.get('rexflashplugin').add(
              this.cursor,
              {
                duration: 700,
                repeat: 1000,
              },
              this,
            );
            if (this.inputText.text.length == 0) this.inputBox.setTexture('typing');
            this.cursor.setVisible(true);
            this.flash.flash();
          },
          this,
        );

        this.inputBox2.on(
          'pointerup',
          () => {
            entry = 1;
            this.flash = this.plugins.get('rexflashplugin').add(
              this.cursor,
              {
                duration: 700,
                repeat: 1000,
              },
              this,
            );
            if (this.inputText.text.length == 0) this.inputBox2.setTexture('typing2');
            this.cursor.setVisible(true);
            this.flash.flash();
          },
          this,
        );
      },
      [],
      this,
    );

    this.anims.create({
      key: 'confetti',
      frames: this.anims.generateFrameNames('confetti', {
        start: 0,
        end: 81,
        zeroPad: 0,
        prefix: 'confetti',
        suffix: '.png',
      }),
      frameRate: 35,
      repeat: 0,
    });

    this.anims.create({
      key: 'coinPile',
      frames: this.anims.generateFrameNames('coinPile', {
        start: 0,
        end: 96,
        zeroPad: 0,
        prefix: 'GoldCoins',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: 'spotlightOpen',
      frames: this.anims.generateFrameNames('spotlight', {
        start: 0,
        end: 188,
        zeroPad: 0,
        prefix: 'spotlight0',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: 'spotlightClose',
      frames: this.anims.generateFrameNames('spotlight', {
        start: 189,
        end: 214,
        zeroPad: 0,
        prefix: 'spotlight0',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: 'endConfetti',
      frames: this.anims.generateFrameNames('endConfetti', {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.input.keyboard.on(
      'keydown',
      function (event) {
        if (entry == 1) {
          this.inputText.setFill('#000000');
          if (
            event.keyCode >= 48 &&
            event.keyCode <= 57 &&
            this.inputText.text.length < 2
          ) {
            this.inputText.text += event.key;
            textArray.push(event.key);
          } else if (event.keyCode == 8 && this.inputText.text.length > 0) {
            this.inputText.text = this.inputText.text.substr(
              0,
              this.inputText.text.length - 1,
            );
            textArray.pop(event.key);
          }

          if (textArray.length == 2) {
            if (textArray[0] == 0) {
              textArray.shift();
              //console.log(textArray);
              this.inputText.text = this.inputText.text.substr(
                1,
                this.inputText.text.length - 1,
              );
            }
          }
          this.flash.stop();
          this.cursor.setVisible(false);
          this.check();
        }
      },
      this,
    );

    //audio
    this.wrongAnswer = this.sound.add('wrongAnswer');
    this.correctAnswer = this.sound.add('correctAnswer');
    this.lockerHandle = this.sound.add('lockerHandle');
    this.lockerDoor = this.sound.add('lockerDoor');
    this.coinReveal = this.sound.add('coinReveal');
  }

  check() {
    if (count > 25 && entry == 1) {
      if (this.inputText.text != '') this.cursor.setVisible(false);

      if (this.inputText.text.length == 0 && entry == 1 && level == 1)
        this.inputBox.setTexture('typing');

      if (this.inputText.text.length == 0 && entry == 1 && level == 2)
        this.inputBox2.setTexture('typing2');

      if (level == 1) {
        if (textArray.length < 2 && textArray[0] != '1') this.inputText.x = 589;
        if (textArray.length < 2 && textArray[0] == '1') this.inputText.x = 592;
        if (textArray.length >= 2 && textArray[0] == '1' && textArray[1] == '1')
          this.inputText.x = 589;
        if (textArray.length >= 2 && textArray[0] == '1' && textArray[1] != '1')
          this.inputText.x = 586;
        if (textArray.length >= 2 && textArray[0] != '1' && textArray[1] == '1')
          this.inputText.x = 585;
        if (textArray.length >= 2 && textArray[0] != '1' && textArray[1] != '1')
          this.inputText.x = 583;

        if ((round == 1 || round == 2) && this.inputText.text == '15')
          this.correctEffect();

        if (
          (round == 1 || round == 2) &&
          this.inputText.text.length != 0 &&
          this.inputText.text != '15'
        )
          this.wrongEffect();

        if (round == 3 && this.inputText.text == '13') this.correctEffect();

        if (round == 3 && this.inputText.text.length != 0 && this.inputText.text != '13')
          this.wrongEffect();
      }

      if (level == 2) {
        if (textArray.length < 2 && textArray[0] != '1') this.inputText.x = 547.5;
        if (textArray.length < 2 && textArray[0] == '1') this.inputText.x = 550;
        if (textArray.length >= 2 && textArray[0] == '1' && textArray[1] == '1')
          this.inputText.x = 546;
        if (textArray.length >= 2 && textArray[0] == '1' && textArray[1] != '1')
          this.inputText.x = 544.5;
        if (textArray.length >= 2 && textArray[0] != '1' && textArray[1] == '1')
          this.inputText.x = 544.3;
        if (textArray.length >= 2 && textArray[0] != '1' && textArray[1] != '1')
          this.inputText.x = 542;

        if (round == 4 && this.inputText.text == '8') this.correctEffect();

        if (round == 4 && this.inputText.text.length != 0 && this.inputText.text != '8')
          this.wrongEffect();

        if (round == 5 && this.inputText.text == '6') this.correctEffect();

        if (round == 5 && this.inputText.text.length != 0 && this.inputText.text != '6')
          this.wrongEffect();

        if (round == 6 && this.inputText.text == '7') this.correctEffect();

        if (round == 6 && this.inputText.text.length != 0 && this.inputText.text != '7')
          this.wrongEffect();
      }
    }
  }
  correctEffect() {
    if (level == 1) this.inputBox.disableInteractive();
    if (level == 2) this.inputBox2.disableInteractive();
    this.input.keyboard.enabled = false;
    this.wrongAnswer.stop(); //audio to avoid the overlapping between incorrect and correct answer sound
    this.correctAnswer.setVolume(0.1).play();
    this.celebrate();
  }

  wrongEffect() {
    if (this.inputText.text.length >= 2) {
      if (level == 1) this.inputBox.setTexture('wrong');
      if (level == 2) this.inputBox2.setTexture('wrong2');
      this.inputText.setFill('#C22300');
      this.wrongAnswer.setVolume(0.1).play(); //audio

      this.time.delayedCall(
        1000,
        () => {
          textArray.length = 0;
          this.inputText.setText('');
          this.cursor.setVisible(true);
          this.flash.flash();
          if (level == 1) this.inputBox.setTexture('typing');
          if (level == 2) this.inputBox2.setTexture('typing2');
        },
        [],
        this,
      );
    }
  }

  celebrate() {
    this.cursor.destroy();
    if (level == 1) this.inputBox.setTexture('correct');
    if (level == 2) this.inputBox2.setTexture('correct2');
    this.inputText.setFill('#149A53');
    entry = 0;
    if (round <= 3)
      this.confetti = this.add
        .sprite(590, 150, 'confetti')
        .setScale(0.6)
        .play('confetti');
    if (round > 3)
      this.confetti = this.add
        .sprite(590, 380, 'confetti')
        .setScale(0.6)
        .play('confetti');

    this.time.delayedCall(
      500,
      () => {
        if (round == 1) {
          this.wheel1.setTexture('wheelGreen1');

          this.rotate1 = this.tweens.add({
            targets: this.wheel1,
            angle: 60,
            duration: 800,
            delay: 250,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });
          this.rotate1.on(
            'start',
            () => {
              this.lockerHandle.setVolume(0.1).play(); //audio
            },
            this,
          );
        }

        if (round == 2) {
          this.wheel1.setTexture('wheelGreen2');

          this.rotate2 = this.tweens.add({
            targets: this.wheel1,
            angle: 120,
            duration: 800,
            delay: 250,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });
          this.rotate2.on(
            'start',
            () => {
              this.lockerHandle.setVolume(0.1).play(); //audio
            },
            this,
          );
        }

        if (round == 3) {
          this.wheel1.setTexture('wheelGreen3');

          this.rotate3 = this.tweens.add({
            targets: this.wheel1,
            angle: 180,
            duration: 800,
            delay: 250,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });
          this.rotate3.on(
            'start',
            () => {
              this.lockerHandle.setVolume(0.1).play(); //audio
            },
            this,
          );
          round++;
        }

        if (round == 4 && level == 2) {
          this.wheel2.setTexture('wheelGreen1');

          this.rotate4 = this.tweens.add({
            targets: this.wheel2,
            angle: 60,
            duration: 800,
            delay: 250,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });
          this.rotate4.on(
            'start',
            () => {
              this.lockerHandle.setVolume(0.1).play(); //audio
            },
            this,
          );
        }

        if (round == 5 && level == 2) {
          this.wheel2.setTexture('wheelGreen2');

          this.rotate5 = this.tweens.add({
            targets: this.wheel2,
            angle: 120,
            duration: 800,
            delay: 250,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });
          this.rotate5.on(
            'start',
            () => {
              this.lockerHandle.setVolume(0.1).play(); //audio
            },
            this,
          );
        }

        if (round == 6 && level == 2) {
          this.wheel2.setTexture('wheelGreen3');

          this.rotate6 = this.tweens.add({
            targets: this.wheel2,
            angle: 180,
            duration: 800,
            delay: 250,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });

          this.rotate6.on(
            'start',
            () => {
              this.lockerHandle.setVolume(0.1).play(); //audio
            },
            this,
          );
          round++;
        }
      },
      [],
      this,
    );

    this.confetti.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE,
      () => {
        if (round <= 2 || (round <= 6 && level == 2)) {
          this.leftText.setText('');
          this.rightText.setText('');
          this.inputText.setText('');

          this.inputText.setFill('#2B2B2B');
          if (level == 1) this.inputBox.setTexture('disabled');
          if (level == 2) {
            this.inputBox2.setTexture('disabled2');
            this.inputBox2.y = 517.5;
          }

          if (level == 1)
            this.cursor = this.add
              .image(597, 282, 'cursor')
              .setScale(0.5)
              .setOrigin(0)
              .setVisible(false);

          if (level == 2)
            this.cursor = this.add
              .image(554, 511, 'cursor')
              .setScale(0.5)
              .setOrigin(0)
              .setVisible(false);

          this.time.delayedCall(
            1000,
            () => {
              round++;
              left = 0;
              right = 0;
              count = 0;
              this.input.keyboard.enabled = true;
              this.cursor.setVisible(false);
            },
            [],
            this,
          );
        }

        if (round == 4 && level == 1) {
          container = this.add.container(0, 0, [
            this.locker1,
            this.wheel1,
            this.leftText,
            this.rightText,
            this.plus,
            this.equal,
            this.inputBox,
            this.inputText,
          ]);

          this.boltTween = this.tweens.add({
            targets: this.bolt,
            y: 296,
            duration: 500,
            delay: 150,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });

          this.boltTween.on(
            'complete',
            () => {
              this.time.delayedCall(
                450,
                () => {
                  this.coinPiles.y = 278;
                  this.coinPiles.x = 460;
                  this.coinPiles.setScale(0.38);
                },
                [],
                this,
              );

              this.lockerDoor.setVolume(0.1).play(); //audio
              this.slideTween = this.tweens.add({
                targets: container,
                x: 260,
                duration: 1000,
                delay: 350,
                ease: 'Power1',
                repeat: 0,
                yoyo: false,
              });

              this.slideTween.on('complete', () => {
                this.coinReveal.setVolume(0.1).play(); //audio
                this.coinPiles.anims.play('coinPile', true);
                this.leftText.setVisible(false);
                this.rightText.setVisible(false);
                this.plus.setVisible(false);
                this.equal.setVisible(false);
                this.inputBox.setVisible(false);
                this.inputText.setVisible(false);
                this.inputText.text = '';
                this.inputText.setFill('#2B2B2B');

                this.time.delayedCall(
                  1500,
                  () => {
                    this.rewardUp = this.tweens.add({
                      targets: goldMeter,
                      displayHeight: 350,
                      y: 305.9,
                      duration: 1000,
                      delay: 200,
                      ease: 'Power1',
                      repeat: 0,
                      yoyo: false,
                    }); //reward bar

                    this.tweens.add({
                      targets: singleCoin,
                      y: 390,
                      duration: 1000,
                      delay: 300,
                      ease: 'Power1',
                      repeat: 0,
                      yoyo: false,
                    }); //reward bar
                  },
                  [],
                  this,
                );

                this.coinPiles.on(
                  Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'coinPile',
                  () => {
                    this.rewardUp.on(
                      'complete',
                      () => {
                        goldMeter.anims.play('goldMeter', true); //reward bar

                        this.tweens.add({
                          targets: container,
                          x: 0,
                          duration: 1000,
                          delay: 350,
                          ease: 'Power1',
                          repeat: 0,
                          yoyo: false,
                        });
                        this.inputBox2.setVisible(true);

                        this.time.delayedCall(
                          2000,
                          () => {
                            this.tweens.add({
                              targets: this.position,
                              x: 453,
                              y: 525,
                              ease: 'Linear',
                              duration: 1000,
                              repeat: 0,
                            });

                            this.time.delayedCall(
                              2000,
                              () => {
                                container2.y = 0;
                              },
                              [],
                              this,
                            );

                            this.time.delayedCall(
                              1500,
                              () => {
                                left = 0;
                                right = 0;
                                count = 0;
                                entry = 0;
                                level = 2;
                                this.leftText.setVisible(true);
                                this.rightText.setVisible(true);
                                this.plus.setVisible(true);
                                this.equal.setVisible(true);
                                this.inputBox2.setVisible(true);

                                this.inputText.setVisible(true);

                                this.leftText.y = 508;
                                this.rightText.x = 593;
                                this.rightText.y = 508;
                                this.plus.x = 527;
                                this.plus.y = 520;
                                this.equal.x = 582;
                                this.equal.y = 520;
                                this.inputText.x = 527;
                                this.inputText.y = 507.5;
                                this.leftText.setFontSize(20);
                                this.rightText.setFontSize(20);
                                this.inputText.setFontSize(20);
                                this.cursor = this.add
                                  .image(554, 511, 'cursor')
                                  .setScale(0.5)
                                  .setOrigin(0)
                                  .setVisible(false);

                                this.cursor.setDepth(4);
                                this.input.keyboard.enabled = true;
                              },
                              [],
                              this,
                            );
                          },
                          [],
                          this,
                        );
                      },
                      this,
                    );
                  },
                  this,
                );
              });
            },
            this,
          );
        } //if close for L-1

        if (round == 7 && level == 2) {
          container3 = this.add.container(0, 0, [
            this.locker2,
            this.wheel2,
            this.leftText,
            this.rightText,
            this.plus,
            this.equal,
            this.inputBox2,
            this.inputText,
          ]);

          this.bolt2Tween = this.tweens.add({
            targets: this.bolt2,
            y: 526,
            duration: 500,
            delay: 150,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });

          this.bolt2Tween.on('complete', () => {
            this.time.delayedCall(
              450,
              () => {
                this.coinPiles2.y = 507;
                this.coinPiles2.x = 460;
                this.coinPiles2.setScale(0.38);
              },
              [],
              this,
            );

            this.lockerDoor.setVolume(0.1).play(); //audio

            this.slide2Tween = this.tweens.add({
              targets: container3,
              x: 260,
              duration: 1000,
              delay: 350,
              ease: 'Power1',
              repeat: 0,
              yoyo: false,
            });

            this.slide2Tween.on(
              'complete',
              () => {
                this.coinReveal.setVolume(0.1).play(); //audio
                this.coinPiles2.anims.play('coinPile', true);
                this.leftText.setVisible(false);
                this.rightText.setVisible(false);
                this.plus.setVisible(false);
                this.equal.setVisible(false);
                this.inputBox2.setVisible(false);
                this.inputText.setVisible(false);
                this.inputText.text = '';
                this.inputText.setFill('#2B2B2B');

                this.time.delayedCall(
                  1500,
                  () => {
                    this.rewardUp2 = this.tweens.add({
                      targets: goldMeter,
                      displayHeight: 640,
                      y: 350.9,
                      duration: 1000,
                      delay: 240,
                      ease: 'Power1',
                      repeat: 0,
                      yoyo: false,
                    }); //reward bar

                    this.tweens.add({
                      targets: singleCoin,
                      y: 310,
                      duration: 1000,
                      delay: 250,
                      ease: 'Power1',
                      repeat: 0,
                      yoyo: false,
                    }); //reward bar
                  },
                  [],
                  this,
                );

                this.coinPiles2.on(
                  Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'coinPile',
                  () => {
                    this.rewardUp2.on(
                      'complete',
                      () => {
                        container2.removeAt(0, true);
                        container2.removeAt(0, true);

                        this.back = this.tweens.add({
                          targets: container3,
                          x: 0,
                          duration: 1000,
                          delay: 350,
                          ease: 'Power1',
                          repeat: 0,
                          yoyo: false,
                        }); //container-3

                        this.back.on(
                          'complete',
                          () => {
                            this.tweens.add({
                              targets: this.position,
                              x: 640,
                              y: 360,
                              ease: 'Linear',
                              onprogress: () => {
                                cam.zoomTo(1.0, 1500);
                              },
                              duration: 1500,
                              repeat: 0,
                            });

                            this.time.delayedCall(
                              2000,
                              () => {
                                this.time.delayedCall(
                                  100,
                                  () => {
                                    this.overlay = this.add
                                      .image(
                                        this.cameras.main.width / 2,
                                        this.cameras.main.height / 2,
                                        'overlay',
                                      )
                                      .setDepth(1)
                                      .setScale(5.0);
                                    container2.setDepth(2);
                                    this.endConfetti = this.add
                                      .sprite(
                                        this.scale.width / 2,
                                        this.scale.height / 2,
                                        'endConfetti',
                                      )
                                      .setDepth(2)
                                      .play('endConfetti');

                                    this.endConfetti.on(
                                      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY +
                                        'endConfetti',
                                      () => {
                                        this.spotlight = this.add
                                          .sprite(
                                            this.cameras.main.width / 2,
                                            this.cameras.main.height / 2,
                                            'spotlight',
                                          )
                                          .play('spotlightOpen');
                                        this.yay = this.add
                                          .sprite(
                                            this.cameras.main.width / 2,
                                            this.cameras.main.height / 2 + 100,
                                            'yay',
                                          )
                                          .setDepth(4)
                                          .setAlpha(0)
                                          .setScale(0.7);

                                        this.tweens.add({
                                          targets: this.yay,
                                          alpha: 1.0,
                                          delay: 250,
                                          duration: 1000,
                                        });

                                        this.time.delayedCall(
                                          1000,
                                          () => {
                                            this.coins = this.add
                                              .sprite(
                                                this.cameras.main.width / 2,
                                                this.cameras.main.height / 2 - 70,
                                                'coins',
                                              )
                                              .setDepth(4)
                                              .setAlpha(0)
                                              .setScale(0.5);

                                            this.tweens.add({
                                              targets: this.coins,
                                              alpha: 1.0,
                                              delay: 250,
                                              duration: 1000,
                                            });

                                            this.buy = this.add
                                              .sprite(
                                                this.cameras.main.width / 2,
                                                this.cameras.main.height / 2 + 200,
                                                'buy',
                                              )
                                              .setDepth(4)
                                              .setAlpha(0)
                                              .setInteractive({ cursor: 'pointer' });

                                            this.tweens.add({
                                              targets: this.buy,
                                              alpha: 1.0,
                                              delay: 250,
                                              duration: 1000,
                                            });

                                            this.buy.on(
                                              'pointerover',
                                              function (pointer) {
                                                this.buy.setTexture('buyBlack');
                                              },
                                              this,
                                            );

                                            this.buy.on(
                                              'pointerout',
                                              function (pointer) {
                                                this.buy.setTexture('buy');
                                              },
                                              this,
                                            );

                                            this.buy.on(
                                              'pointerdown',
                                              function (pointer) {
                                                this.scene.start('EndScene');
                                                this.scene.stop('GameScene');
                                              },
                                              this,
                                            );
                                          },
                                          [],
                                          this,
                                        );
                                      },
                                      this,
                                    );
                                  },
                                  [],
                                  this,
                                );
                              },
                              [],
                              this,
                            );
                          },
                          this,
                        ); //back complete tween
                      },
                      this,
                    ); //reward complete
                  },
                  this,
                ); //coinpiles complete
              },
              this,
            ); //slide2tween complete
          }); //bolt-2 tween complete
        } //if close for L-2
      },
      this,
    ); //confetti animation completion close
  }

  update() {
    if (left == 0 && right == 0 && count <= 25 && round <= 6) {
      this.cursor.setVisible(false);
      this.lnum = Phaser.Math.RND.pick([3, 9, 1, 7, 6, 5, 8, 2, 4]);
      this.rnum = Phaser.Math.RND.pick([1, 2, 3, 4, 5, 6, 7, 8, 9]);
      if (round >= 4)
        this.rnum = Phaser.Math.RND.pick([
          11, 0, 17, 19, 14, 15, 20, 12, 3, 16, 9, 10, 5, 6, 23,
        ]);
      this.leftText.text = this.lnum;
      this.rightText.text = this.rnum;

      left = 1;
      right = 1;
      count++;
      if (count > 25) {
        textArray.length = 0;
        if (round == 1) {
          this.leftText.text = '9';
          this.rightText.text = '6';
        }

        if (round == 2) {
          this.leftText.text = '7';
          this.rightText.text = '8';
        }

        if (round == 3) {
          this.leftText.text = '8';
          this.rightText.text = '5';
        }

        if (round == 4) {
          this.leftText.text = '9';
          this.rightText.text = '17';
        }

        if (round == 5) {
          this.leftText.text = '8';
          this.rightText.text = '14';
        }
        if (round == 6) {
          this.leftText.text = '7';
          this.rightText.text = '14';
        }
        if (level == 1) {
          this.inputBox.setTexture('default');
          this.inputBox.setInteractive({ cursor: 'pointer' });
        }
        if (level == 2) {
          this.inputBox2.setTexture('default2');
          this.inputBox2.y = 519.3;
          this.inputBox2.setInteractive({ cursor: 'pointer' });
        }
      }
      this.time.delayedCall(
        35,
        () => {
          left = 0;
          right = 0;
        },
        [],
        this,
      );
    }
    if (this.inputText.text != '') this.cursor.setVisible(false);

    if (this.count <= 25) this.cursor.setVisible(false);

    cam.centerOn(this.position.x, this.position.y);
  }
}

//parallel scene for the reward bar
export class DemoScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'DemoScene',
    });
  }

  preload() {}

  create() {
    this.anims.create({
      key: 'singleCoin',
      frames: this.anims.generateFrameNames('singleCoin', {
        start: 0,
        end: 47,
        zeroPad: 0,
        prefix: 'GoldCoin',
        suffix: '.png',
      }),
      frameRate: 35,
      repeat: -1,
    }); //reward bar

    //reward bar
    bar = this.add.image(-150, 148, 'bar').setScale(0.9);
    reward = this.add.image(-150, 237, 'reward').setScale(0.35);
    goldMeter = this.add.sprite(442, 260, 'goldMeter').setScale(1.019);
    goldMeter.displayHeight = 50;
    bottom = this.add.image(-149.15, 259.8, 'bottom').setScale(0.938);
    singleCoin = this.add.sprite(430.3, 479.2, 'singleCoin').play('singleCoin');
    //reward bar
    container2 = this.add.container(-20, 0);
    container2.add([bar, reward, goldMeter, bottom, singleCoin]);
    //console.log(container2.x);

    this.anims.create({
      key: 'goldMeter',
      frames: this.anims.generateFrameNames('goldMeter', {
        start: 0,
        end: 47,
        zeroPad: 0,
        prefix: 'GoldMeter',
        suffix: '.png',
      }),
      frameRate: 35,
      repeat: -1,
    }); //reward bar
  }
  update() {}
}
